import { IGetAllContratoFinanceiroUseCase } from "../../../presentation/useCases/read/get_all_contrato_financeiro_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { ModelContratoFinanceiroLista } from "../../models/contrato_financeiro_lista";

/**
 * GetAllContratoFinanceiroUseCase
 */

export class GetAllContratoFinanceiroUseCase
  extends BasePaginatedUseCase<ModelContratoFinanceiroLista>
  implements IGetAllContratoFinanceiroUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllContratoFinanceiro(
    idsCliente: number[],
    idsCentroCusto: number[],
    descricao: string | null,
    codigo: number | null,
    dataReceberDe: Date | null,
    dataReceberAte: Date | null,
    status: number[] | null,
    dataInicioDe: Date | null,
    dataInicioAte: Date | null,
    page: number | undefined,
    rowsPerPage: number | undefined
  ): Promise<void> {

    const result = await this.repository.getAllContratoFinanceiroListaWithFilters(
      idsCliente,
      idsCentroCusto,
      descricao,
      codigo,
      dataReceberDe,
      dataReceberAte,
      status,
      dataInicioDe,
      dataInicioAte,
      page,
      rowsPerPage
    )

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;

  }
}
